var $3fb4818863a55ec8$exports = {};
$3fb4818863a55ec8$exports = {
    "(optional)": `\u{FF08}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{FF09}`,
    "(required)": `\u{FF08}\u{5FC5}\u{9808}\u{FF09}`
};


export {$3fb4818863a55ec8$exports as default};
//# sourceMappingURL=ja-JP.mjs.map
